import React from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import AuthInitializer from "./Components/AuthInitializer";
import DepositStrip from "./Components/DepositStrip";
import Slider from "./Components/Slider";
import LoadingPopup from "./Components/LoadingPopup";

const layout = ({ children }) => {
  return (
    <div className="dark:bg-darkblue">
      <DepositStrip />
      <AuthInitializer />
      <Header />
      <Slider />
      <LoadingPopup />
      <main className="dark:bg-darkblue">{children}</main>
      <Footer />
    </div>
  );
};

export default layout;
